import { useCallback } from "react";
import { CompanyService } from "../core/http/service/CompanyService";
import { PersonService } from "../core/http/service/PersonService";
import { UserRoleService } from "../core/http/service/UserRoleService";

const useFetchCareLinesOccupHealthHelper = (pessoa: any) => {

    var idPessoa = pessoa.idPessoa ? pessoa.idPessoa :  pessoa.id;
    
    const fetchPersonOccupHealth = useCallback(async () => {      
        
        const service: UserRoleService = new UserRoleService();
        const companyService: CompanyService = new CompanyService();
        const companies: any[] = [];
        const ghes: any[] = [];
        const response: any = await service.getByPersonId(idPessoa);
        response.data.data.forEach((d: any) => {
            companies.push(d.empresa);
        })
        for (let company of companies) {
            
            const result: any = await companyService.getPeriodicsByCompanyPerson(company.id, idPessoa)
            for (let r of result.data.data) {
                const response: any = await companyService.getCompanySaudeOcupacionalByName(r.nome, company.id)
                const ghe: any = response.data.data[0];
                ghes.push({ ...ghe, nomeEmpresa: company.nomeFantasia });
            }
        }
        return ghes;

    }, [pessoa])

    const fetchPersonCareLines = useCallback(async () => {
        const service: PersonService = new PersonService();
        const careLines: any[] = [];
        try {
            const result: any = await service.getMyCareLinesById(idPessoa);
            result.data.data.forEach((d: any) => {
                careLines.push(d)
            })
            return careLines
        } catch (error: any) {
            console.log(error)
        }
    }, [pessoa])


    return { 
        fetchPersonCareLines,
        fetchPersonOccupHealth
    }
}

export default useFetchCareLinesOccupHealthHelper;